import { API } from '../config/config';

let _cacheCustomers = null;
let _cacheTimeCustomers = 0;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

const CustomerService = {
  getAll: () => getCustomers()
};

const getCustomers = async () => {
  const now = Date.now();
  if (_cacheCustomers && (now - _cacheTimeCustomers) < CACHE_TTL_MS) {
    return _cacheCustomers;
  }
  try {
    const response = await API.get('/customers');
    _cacheCustomers = response.data;
    _cacheTimeCustomers = now;
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

export default CustomerService;
